import axios from '../../../http';

const state = {};

const getters = {};

const actions = {
  async sendHoldSwitchEmail({ state, rootState, dispatch, commit }) {
    const { emailAddress, title, firstName, lastName } = rootState.personal_details_customer;
    const { tariffName, supplierId } = rootState.personal_details_switch_plan;
    try {
      const res = await axios({
        method: 'POST',
        baseURL: '/',
        url: 'email/holdswitchsendemail',
        data: { email: emailAddress, tariffName, supplierId, title, firstName, lastName }
      });

      return res;
    } catch (err) {
      return err;
    }
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
